<style scoped lang="scss">
.batch-mold-prepare-dialog {
  .batch-mold-search {
    margin-bottom: 10px;
  }
  .batch-mold-table-wrap {
    margin-top: 10px;
  }
  .batch-mold-pagination {
    margin-top: 10px;
    text-align: right;
  }
  .execute-result-success {
    color: #67c23a;
  }
  .execute-result-fail {
    color: #f56c6c;
  }
}
</style>

<template>
  <el-dialog
    class="batch-mold-prepare-dialog"
    :title="$t('批量备模')"
    :visible.sync="dialogVisible"
    width="95%"
    append-to-body
    :close-on-click-modal="false"
    @close="onDialogClose"
  >
    <el-form size="mini" :inline="true" :model="conditions" class="batch-mold-search demo-form-inline">
      <el-form-item :label="$t('beimozhuangtai')">
        <yi_dictionary_select multiple :max="10" :type="'MOLD_PREPARATION_STATUS'" :ids.sync="conditions.moldPrepareStatusList"></yi_dictionary_select>
      </el-form-item>
      <el-form-item :label="$t('guishuchejian')">
        <yi_data_select :max="1" :type="'organization'" :idsPath.sync="conditions.orgIds" :ids.sync="conditions.orgId"></yi_data_select>
      </el-form-item>
      <el-form-item :label="$t('工单计划开始时间')">
        <yi_time_input type="datetimerange" :start.sync="conditions.planStartTimeBegin" :end.sync="conditions.planStartTimeEnd" :maxTime="2592000000"></yi_time_input>
      </el-form-item>
      <el-form-item :label="$t('产前准备创建时间')">
        <yi_time_input type="datetimerange" :start.sync="conditions.createTimeBegin" :end.sync="conditions.createTimeEnd" :maxTime="2592000000"></yi_time_input>
      </el-form-item>
      <el-form-item>
        <el-button @click="resetSearch">{{ $t('chongzhi') }}</el-button>
        <el-button type="primary" :loading="searchLoading" @click="search">{{ $t('sousuo') }}</el-button>
      </el-form-item>
    </el-form>

    <div class="batch-mold-table-wrap">
      <el-table
        ref="batchMoldTableRef"
        size="mini"
        border
        stripe
        height="420"
        :data="tableData"
        v-loading="searchLoading"
        row-key="preparationId"
        @selection-change="onSelectionChange"
      >
        <el-table-column type="selection" width="45" reserve-selection></el-table-column>
        <el-table-column :label="$t('执行结果')" prop="executeResult" width="120" fixed="left">
          <template slot-scope="scope">
            <span v-if="scope.row.executeResult" :class="getExecuteResultClass(scope.row.executeResult)">{{ scope.row.executeResult }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('mujuchukudanhao')" prop="moldOutboundNo" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('banci')" width="80" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.shift && scope.row.shift.name ? scope.row.shift.name : '' }}</template>
        </el-table-column>
        <el-table-column :label="$t('mujubianhao')" width="120" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.mould && scope.row.mould.no ? scope.row.mould.no : '' }}</template>
        </el-table-column>
        <el-table-column :label="$t('mujumingcheng')" width="120" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.mould && scope.row.mould.name ? scope.row.mould.name : '' }}</template>
        </el-table-column>
        <el-table-column :label="$t('模具位置')" width="100" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.mould && scope.row.mould.location ? scope.row.mould.location : '' }}</template>
        </el-table-column>
        <el-table-column :label="$t('shebeimingcheng')" width="100" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.equipment && scope.row.equipment.name ? scope.row.equipment.name : '' }}</template>
        </el-table-column>
        <el-table-column :label="$t('shengchangongdan')" width="130" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.wo && scope.row.wo.no ? scope.row.wo.no : '' }}</template>
        </el-table-column>
        <el-table-column :label="$t('jihuashuliang')" width="90">
          <template slot-scope="scope">{{ scope.row.wo && scope.row.wo.planQuantity != null ? scope.row.wo.planQuantity : '' }}</template>
        </el-table-column>
        <el-table-column :label="$t('产品编码')" width="120" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.material && scope.row.material.code ? scope.row.material.code : '' }}</template>
        </el-table-column>
        <el-table-column :label="$t('产品名称')" width="120" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.material && scope.row.material.name ? scope.row.material.name : '' }}</template>
        </el-table-column>
        <el-table-column :label="$t('产品规格')" width="100" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.material && scope.row.material.spec ? scope.row.material.spec : '' }}</template>
        </el-table-column>
        <el-table-column :label="$t('产品材质')" width="100" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.material && scope.row.material.ingredient ? scope.row.material.ingredient : '' }}</template>
        </el-table-column>
        <el-table-column :label="$t('产品颜色')" width="80" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.material && scope.row.material.color ? scope.row.material.color : '' }}</template>
        </el-table-column>
        <el-table-column :label="$t('guishuchejian')" width="100" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.org && scope.row.org.name ? scope.row.org.name : '' }}</template>
        </el-table-column>
        <el-table-column :label="$t('工单计划开始时间')" width="150">
          <template slot-scope="scope">{{ formatTime(scope.row.planStartTime) }}</template>
        </el-table-column>
        <el-table-column :label="$t('产前准备创建时间')" width="150">
          <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
        </el-table-column>
        <el-table-column :label="$t('beimozhuangtai')" width="90">
          <template slot-scope="scope">
            <span v-if="scope.row.moldPrepareStatus != null && scope.row.moldPrepareStatus !== ''">
              {{ $t(store.state.dictJson['MOLD_PREPARATION_STATUS'][scope.row.moldPrepareStatus]) }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="batch-mold-pagination" v-if="pagination.total > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        ></el-pagination>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">{{ $t('quxiao') }}</el-button>
      <el-button size="mini" type="primary" :disabled="selectedRows.length === 0" :loading="prepareLoading" @click="batchPrepareSubmit">
        {{ $t('批量备模') }}
      </el-button>
      <el-button size="mini" type="primary" :disabled="selectedRows.length === 0" :loading="exportLoading" @click="exportExcel">
        {{ $t('打印模具排产出库统计表') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script type="text/javascript">
import XLSX from 'xlsx';

export default {
  name: 'batch_mold_prepare_dialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchLoading: false,
      prepareLoading: false,
      exportLoading: false,
      conditions: this.getDefaultConditions(),
      tableData: [],
      selectedRows: [],
      syncingSelection: false,
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.open();
      }
    }
  },
  methods: {
    getDefaultTimeRange() {
      return {
        begin: this.dayjs().subtract(1, 'month').startOf('day').valueOf(),
        end: this.dayjs().endOf('day').valueOf()
      };
    },
    getDefaultConditions() {
      const timeRange = this.getDefaultTimeRange();
      return {
        moldPrepareStatusList: ['0'],
        orgIds: null,
        selectOrgId: null,
        planStartTimeBegin: timeRange.begin,
        planStartTimeEnd: timeRange.end,
        createTimeBegin: timeRange.begin,
        createTimeEnd: timeRange.end
      };
    },
    open() {
      this.conditions = this.getDefaultConditions();
      this.tableData = [];
      this.selectedRows = [];
      this.pagination.pageNum = 1;
      this.$nextTick(() => {
        if (this.$refs.batchMoldTableRef) {
          this.$refs.batchMoldTableRef.clearSelection();
        }
        this.search();
      });
    },
    onDialogClose() {
      this.tableData = [];
      this.selectedRows = [];
      this.conditions = this.getDefaultConditions();
      this.pagination.pageNum = 1;
      this.pagination.total = 0;
    },
    buildQueryParams() {
      const params = {
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize
      };
      if (this.conditions.moldPrepareStatusList && this.conditions.moldPrepareStatusList.length) {
        params.moldPrepareStatusList = this.conditions.moldPrepareStatusList;
      }
      ['planStartTimeBegin', 'planStartTimeEnd', 'createTimeBegin', 'createTimeEnd'].forEach(key => {
        const val = this.conditions[key];
        if (val !== null && val !== undefined && val !== '') {
          params[key] = val;
        }
      });
      if (this.conditions.orgId) {
        params.orgId = this.conditions.orgId;
      }
      params.manufacturingProcess = '01';
      return params;
    },
    search(preserveState) {
      this.searchLoading = true;
      const selectedIds = preserveState ? this.selectedRows.map(row => row.preparationId) : [];
      const executeResultMap = {};
      if (preserveState) {
        this.tableData.forEach(row => {
          if (row.executeResult) {
            executeResultMap[row.preparationId] = row.executeResult;
          }
        });
      }
      return this.http
        .get('/web/prepartion/batchQueryMoldPrepare', { params: this.buildQueryParams() })
        .then(res => {
          const data = res.data || {};
          const list = (data.rows || []).map(item => ({
            ...item,
            executeResult: preserveState ? executeResultMap[item.preparationId] || '' : ''
          }));
          this.tableData = list;
          this.pagination.total = data.total || 0;
          if (preserveState) {
            this.$nextTick(() => {
              this.restoreSelection(selectedIds);
            });
          } else {
            this.selectedRows = [];
            this.$nextTick(() => {
              if (this.$refs.batchMoldTableRef) {
                this.$refs.batchMoldTableRef.clearSelection();
              }
            });
          }
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        })
        .finally(() => {
          this.searchLoading = false;
        });
    },
    resetSearch() {
      this.conditions = this.getDefaultConditions();
      this.pagination.pageNum = 1;
      this.search();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.pageNum = 1;
      this.search();
    },
    handleCurrentChange(val) {
      this.pagination.pageNum = val;
      this.search();
    },
    onSelectionChange(rows) {
      if (this.syncingSelection) {
        return;
      }
      this.selectedRows = rows || [];
    },
    restoreSelection(selectedIds) {
      if (!this.$refs.batchMoldTableRef || !selectedIds || selectedIds.length === 0) {
        this.selectedRows = [];
        return;
      }
      const idSet = new Set(selectedIds);
      this.syncingSelection = true;
      this.$refs.batchMoldTableRef.clearSelection();
      const selectedRows = [];
      this.tableData.forEach(row => {
        if (idSet.has(row.preparationId)) {
          this.$refs.batchMoldTableRef.toggleRowSelection(row, true);
          selectedRows.push(row);
        }
      });
      this.selectedRows = selectedRows;
      this.$nextTick(() => {
        this.syncingSelection = false;
      });
    },
    formatTime(time) {
      if (!time) {
        return '';
      }
      return this.dayjs(time).format('YYYY-MM-DD HH:mm:ss');
    },
    getExecuteResultClass(result) {
      if (!result) {
        return '';
      }
      if (result === '成功' || result.indexOf('成功') === 0) {
        return 'execute-result-success';
      }
      if (result.indexOf('失败') === 0) {
        return 'execute-result-fail';
      }
      return '';
    },
    async batchPrepareSubmit() {
      if (this.selectedRows.length === 0) {
        return;
      }
      this.prepareLoading = true;
      const pageLoading = this.$loading({
        lock: true,
        text: this.$t('批量备模中'),
        background: 'rgba(0, 0, 0, 0.5)'
      });
      try {
        for (let i = 0; i < this.selectedRows.length; i++) {
          const row = this.selectedRows[i];
          try {
            await this.http.post('/web/prepartion/moldPrepare', row.preparationId);
            this.$set(row, 'executeResult', '成功');
          } catch (msg) {
            const reason = this.$t(msg) || msg || '';
            this.$set(row, 'executeResult', reason ? `失败-${reason}` : '失败');
          }
        }
        await this.search(true);
        this.$emit('refreshed');
      } finally {
        this.prepareLoading = false;
        pageLoading.close();
      }
    },
    async exportExcel() {
      if (this.selectedRows.length === 0) {
        return;
      }
      this.exportLoading = true;
      try {
        await this.search(true);
        await this.$nextTick();
        const sortedList = [...this.selectedRows].sort((a, b) => {
          const ta = a.planStartTime ? new Date(a.planStartTime).getTime() : 0;
          const tb = b.planStartTime ? new Date(b.planStartTime).getTime() : 0;
          return ta - tb;
        });
        const title = this.$t('模具排产出库统计表');
        const headers = [
          this.$t('xuhao'),
          this.$t('mujuchukudanhao'),
          this.$t('banci'),
          this.$t('mujubianhao'),
          this.$t('模具位置'),
          this.$t('机台'),
          this.$t('wuliaomingcheng'),
          this.$t('guigexinghao'),
          this.$t('产品生产材质'),
          this.$t('yanse'),
          this.$t('jihuashuliang'),
          this.$t('liaohao'),
          this.$t('beizhu')
        ];
        const colCount = headers.length - 1;
        const tableData = [];
        const titleRow = [title];
        for (let i = 1; i < headers.length; i++) {
          titleRow.push('');
        }
        tableData.push(titleRow);
        tableData.push(headers);
        sortedList.forEach((row, index) => {
          tableData.push([
            index + 1,
            row.moldOutboundNo || '',
            (row.shift && row.shift.name) || '',
            (row.mould && row.mould.no) || '',
            (row.mould && row.mould.location) || '',
            (row.equipment && row.equipment.name) || '',
            (row.material && row.material.name) || '',
            (row.material && row.material.spec) || '',
            (row.material && row.material.ingredient) || '',
            (row.material && row.material.color) || '',
            row.wo && row.wo.planQuantity != null ? row.wo.planQuantity : '',
            (row.material && row.material.no) || '',
            ''
          ]);
        });
        const worksheet = XLSX.utils.aoa_to_sheet(tableData);
        if (!worksheet['!merges']) {
          worksheet['!merges'] = [];
        }
        worksheet['!merges'].push({
          s: { r: 0, c: 0 },
          e: { r: 0, c: colCount }
        });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        XLSX.writeFile(workbook, `${title}_${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
      } catch (e) {
        this.utils.errorMessage(e);
      } finally {
        this.exportLoading = false;
      }
    }
  }
};
</script>
